import axios from 'axios';
import { canvasContext, canvasPageContext } from '@/services/canvasContext';

export default {
  data() {
    return { lastPage: '', pageTimer: null };
  },
  computed: {
    page() {
      const r = this.$route;
      const ent = this.$store.state.entity || {};
      const ten = this.$store.state.tenant || {};
      const title = String(document.title || '').replace(/\s*\|\s*Kairon Health\s*$/, '');
      const ids = r.params.entityIds;
      const routeEntity = r.params.entityId || r.params.entity_id || (Array.isArray(ids) ? ids[0] : ids) || null;
      const entity = routeEntity
        ? { id: routeEntity, name: String(routeEntity) === String(ent.current_entity_id) ? (ent.current_entity_name || '') : '' }
        : null;
      return {
        route: r.name || '', path: r.fullPath || r.path || '', title,
        tenant: ten.current_tenant_name || ten.current_tenant_slug || '',
        params: { ...(r.params || {}) }, query: { ...(r.query || {}) },
        entity,
        canvas: canvasPageContext(),
      };
    },
    sessionLive() {
      return ['launching', 'ready', 'thinking', 'rate_limited'].includes(this.entry.state.connState);
    },
    canvasStamp() {
      if (!canvasContext.active) return '';
      return JSON.stringify(canvasPageContext());
    },
    pageContextPaused() {
      return false;
    },
  },
  watch: {
    '$route.fullPath'() {
      this.tellPage();
    },
    canvasStamp() {
      this.tellPage();
    },
    sessionLive(live) {
      if (live) this.tellPage(true);
    },
  },
  beforeUnmount() {
    clearTimeout(this.pageTimer);
  },
  methods: {
    tellPage(force = false) {
      if (!this.sessionLive || !this.entry.sessionId || this.pageContextPaused) return;
      clearTimeout(this.pageTimer);
      this.pageTimer = setTimeout(() => {
        const page = this.page;
        const stamp = JSON.stringify(page);
        if (!force && stamp === this.lastPage) return;
        this.lastPage = stamp;
        const conv = this.$refs.conversation;
        if (conv) conv.sendPageContext(page);
        else axios.post(`/api/impact_analytics/agent-sessions/${this.entry.sessionId}/turn/`, { type: 'page_context', page }).catch(() => {});
      }, 600);
    },
    scrollChat() {
      if (this.$refs.conversation) this.$refs.conversation.scrollChat();
    },
    scrollArtifacts() {},
    startRunPolling() {},
    stopRunPolling() {},
    fetchRunPlots() {},
  },
};
